import { filterPage } from "components/common/Filters/FiltersHelper";
import React from "react";
import { ABOVE_PROPERTY } from "utils/CommonConstants";
import { Comments } from "../Comments";
import Sections from "../Sections/List";

const CommentsTab = React.memo(({ planId }: { planId?: string }) => {
  if (!planId) return null;
  return <Comments planId={planId} />;
});

export const getTabDetails = (selectedMyPlanDetail: any, planType: string) => {
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;

  let common = [
    {
      label: "Action Plan",
      content: () => <Sections selectedPlanDetail={selectedMyPlanDetail} planType={planType} />,
      filtersToClear: [filterPage.planProgressFromLibraryDisplay, filterPage.libraryPlanDetailsDisplay]
    }
  ];

  return isTemplatePlan
    ? common
    : [
        ...common,
        {
          label: "Comments",
          content: () => <CommentsTab planId={selectedMyPlanDetail?.id} />
        }
      ];
};
